// src/Components/Error/NotFoundPage.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Meta from "../Meta/Meta";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Meta
        title="404 - Page Not Found | ALGermanist"
        description="We couldn't find the page you're looking for. Return to ALGermanist home."
        keywords="404, not found, ALGermanist"
      />
    <Box textAlign="center" mt={10}>
      <Typography variant="h3" color="error" gutterBottom>
        ? Page Not Found
      </Typography>
      <Typography variant="h6" gutterBottom>
        The page you�re looking for doesn�t exist.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate("/")}>
        Go to Homepage
      </Button>
    </Box>
    </>
  );
};

export default NotFoundPage;
